import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_FINANCEIRO = [
  {
    module: 'FIN_EQP_VENDA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'supervisor.parceiro.nome_razao_social'
      }
    ]
  },
  {
    module: 'FIN_INST_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'cnpj'
      }
    ]
  },
  {
    module: 'FIN_FORMA_PAGTO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagamento_sefaz.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'a_prazo'
      }
    ]
  },
  {
    module: 'FIN_FORMA_PAGTO_SEFAZ',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  },
  {
    module: 'FIN_COND_PAGTO',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'descricao',
        active: true,
        removable: false
      },
      {
        field: 'catalogo_usa',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'FIN_CENTRO_RESULTADO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'centro_resultado.descricao'
      }
    ]
  },
  {
    module: 'FIN_NAT_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'natureza_financeira.descricao'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'periodicidade'
      }
    ]
  },
  {
    module: 'FIN_CONTAS_RECEBER',
    colunas: [
      { field: 'numero_doc', active: true, removable: false },
      { field: 'created_at', active: true, removable: true },
      { field: 'forma_pagto.nome', active: true, removable: true },
      { field: 'vencimento', active: true, removable: true },
      { field: 'valor', active: true, removable: true },
      { field: 'dias_atraso', active: true, removable: true },
      { field: 'valor_juros', active: true, removable: true },
      { field: 'valor_multa', active: true, removable: true },
      { field: 'valor_mora', active: true, removable: true },
      { field: 'pagamentos', active: true, removable: true },
      { field: 'valor_total_pagtos', active: true, removable: true },
      { field: 'valor_total_ha_pagar', active: true, removable: true },
      { field: 'valor_total_ha_pagar_juros', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'FIN_CONTAS_PAGAR',
    colunas: [
      { field: 'numero_doc', active: true, removable: false },
      { field: 'created_at', active: true, removable: true },
      { field: 'forma_pagto.nome', active: true, removable: true },
      { field: 'vencimento', active: true, removable: true },
      { field: 'valor', active: true, removable: true },
      { field: 'dias_atraso', active: true, removable: true },
      { field: 'valor_juros', active: true, removable: true },
      { field: 'valor_multa', active: true, removable: true },
      { field: 'valor_mora', active: true, removable: true },
      { field: 'pagamentos', active: true, removable: true },
      { field: 'valor_total_pagtos', active: true, removable: true },
      { field: 'valor_total_ha_pagar', active: true, removable: true },
      { field: 'valor_total_ha_pagar_juros', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'FIN_PORTADOR',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'padrao'
      },
      {
        active: true,
        removable: true,
        field: 'saldo_inicial'
      },
      {
        active: true,
        removable: true,
        field: 'saldo'
      }
    ]
  },
  {
    module: 'FIN_MOV_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'portador.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'observacao'
      },
      {
        active: true,
        removable: false,
        field: 'nome_parceiro'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'data_movimento'
      },
      {
        active: true,
        removable: true,
        field: 'is_conciliado'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  }
] as IColunasSettingsUser[];
